import api from '@/api'

export const countries = {
  namespaced: true,
  state: {
    countries: [],
    stateProvinces: []
  },
  getters: {
    countries: state => state.countries,
    stateProvinces: state => state.stateProvinces
  },
  actions: {
    getAllCountries({ commit }) {
      return new Promise((resolve, reject) => {
        api.getAllCountries({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_COUNTRIES', JSON.parse(response.data))
            resolve(response)
          })
      })
    },
    getStateProvinces({ commit }, id) {
      return new Promise((resolve, reject) => {
        api.getStateProvinces(id)
          .then(response => {
            commit('SET_STATE_PROVINCES', response.data)
            resolve(response)
          })
      })
    },
    resetStateProvinces({ commit }) {
      commit('SET_STATE_PROVINCES', null)
    },
    upsertCountry({ commit }, country) {
      return new Promise((resolve, reject) => {
        api.upsertCountry(country)
          .then(response => {
            country.id = response.data
            if (response.status === 200) {
              commit('SET_COUNTRY', country)
            }
            resolve(response)
          })
      })
    },
    upsertStateProvince({ commit }, stateProvince) {
      return new Promise((resolve, reject) => {
        api.upsertStateProvince(stateProvince)
          .then(response => {
            stateProvince.id = response.data
            if (response.status === 200) {
              commit('SET_STATE_PROVINCE', stateProvince)
            }
            resolve(response)
          })
      })
    },
    deleteStateProvince({ commit }, stateProvince) {
      return new Promise((resolve, reject) => {
        api.deleteStateProvince(stateProvince)
          .then(response => {
            resolve(response)
          })
      })
    }
  },
  mutations: {
    SET_COUNTRIES(state, data) {
      state.countries = data
    },
    SET_COUNTRY(state, data) {
      // Check if 'id' is an object (indicating an error)
      if (typeof data.id === 'object' && data.id.error) {
        return // Stop further processing
      }

      // 'id' is valid, so proceed with finding or adding the country
      var idx = state.countries.findIndex(i => i.id === data.id)

      if (parseInt(idx) !== -1) {
        // Update the existing country
        state.countries[idx].name = data.name
        state.countries[idx].abbreviation = data.abbreviation
      } else {
        // Add new country to the array
        const lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation
        }
        state.countries.push(lookup)
      }
    },
    SET_STATE_PROVINCES(state, stateProvinces) {
      state.stateProvinces = stateProvinces || []
    },
    SET_STATE_PROVINCE(state, data) {
      // Check if 'id' is an object (indicating an error)
      if (typeof data.id === 'object' && data.id.error) {
        return // Stop further processing
      }

      // 'id' is valid, so proceed with finding or adding the state/province
      var idx = state.stateProvinces.findIndex(i => i.id === data.id)

      if (parseInt(idx) !== -1) {
        // Update the existing country
        state.stateProvinces[idx].name = data.name
        state.stateProvinces[idx].abbreviation = data.abbreviation
      } else {
        // Add new country to the array
        const lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation,
          countryId: data.countryId
        }
        state.stateProvinces.push(lookup)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/countries/index.js